import type { ReactNode } from 'react'
import mark from './assets/everhall-mark.svg'

export function StatusScreen(props: { title: string; detail?: string; children?: ReactNode }) {
  return (
    <div className="status-screen">
      <div className="status-card">
        {/* The mark first: a dead end with no brand and no way back reads as
            a crash, not an outcome. */}
        <img src={mark} alt="" width={32} height={32} className="status-card__mark" />
        <h1>{props.title}</h1>
        {props.detail ? <p>{props.detail}</p> : null}
        {props.children}
      </div>
    </div>
  )
}
